// ── EMPLACEMENTS D’IMAGES (Arts Martiaux Enfants — Cours Prêts™, version FR) ──────────────────
// Hébergées dans les ressources (Recursos) de la boutique Impultienda française.
const STORE = '4c0687fe-74e0-49a5-b28c-bf52cbd96bce';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/** iMac + 3 tablettes + 2 téléphones, un bonus par appareil, fond blanc. */
const IMAC = RES + '1792778292612_fr-mockup-imac-aff9f8be.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Vraies pages du livre Gamma Studio (9:16), même ordre que lookInside.captions : p.7, 11, 12, 13, 36, 39 */
export const pageImages: string[] = [
  RES + '1792778315843_fr-pagina-07-660a3fda.webp',
  RES + '1792778341899_fr-pagina-11-8e0f2c42.webp',
  RES + '1792778321967_fr-pagina-12-7933644f.webp',
  RES + '1792778326107_fr-pagina-13-c7908faf.webp',
  RES + '1792778330219_fr-pagina-36-49ae8e53.webp',
  RES + '1792778333968_fr-pagina-39-5bfc7915.webp',
];
/** 5 couvertures de bonus (style Collage, générées par la boutique, titres déjà en français), même ordre que les bonus et le checkout */
export const bonusCovers: string[] = [
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/4c0687fe-74e0-49a5-b28c-bf52cbd96bce/8548e9d3-deb6-46f1-9920-e8cca604adf7-mockup.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/4c0687fe-74e0-49a5-b28c-bf52cbd96bce/aecb9eaf-6b5b-4b44-a001-1aa0a6bc9c96-mockup.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/4c0687fe-74e0-49a5-b28c-bf52cbd96bce/8948f5b2-ae42-44fc-a808-43725eb09e36-mockup.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/4c0687fe-74e0-49a5-b28c-bf52cbd96bce/4a462fe9-dab6-4695-8a82-55b9ca88ed7a-mockup.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/4c0687fe-74e0-49a5-b28c-bf52cbd96bce/5812184c-70f3-483f-b17a-56d5959c8ccf-mockup.webp',
];
